<div class="row">
  <div class="col-12 text-center">
      <div class="alert alert-warning  text-center" role="alert">
          <i class="fa fa-spinner fa-2x fa-spin"  style="font-size: 25px"></i>
          <br>
          <p><strong>Please Wait</strong>
            <br> Redirecting  to BOCW Service......
            <br><strong> Please don't close the tab</strong>
          </p>
      </div>
  </div>
</div>